import Api from "../../utils/axios";

export const dashboardApi = {
  getKPIData: () => Api.get("admin/get-dasboard-data"),
  getOrderAnalytics: (payload) => Api.post("admin/get-order-analytics",payload),
  getEarningAnalytics: (payload) => Api.post("admin/get-earning-analytics",payload),

  
};


